import EventEmitter from '@/common/EventEmitter';

/**
 *
 *
 * @class SyncCenterEventBus
 * @extends {EventEmitter}
 * SyncCenter的事件总线
 * 由于SyncCenter在登陆态切换时会重新创建实例，这里需要一层单例来确保广播事件的监听逻辑正常
 */
class SyncCenterEventBus extends EventEmitter {
  private constructor() {
    super();
  }

  private static instance?: SyncCenterEventBus;

  public static getInstance(): SyncCenterEventBus {
    if (SyncCenterEventBus.instance) return SyncCenterEventBus.instance;

    SyncCenterEventBus.instance = new SyncCenterEventBus();
    return SyncCenterEventBus.instance;
  }
}

export const syncCenterEventBus = SyncCenterEventBus.getInstance();
